var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-f3", staticStyle: { "min-height": "900px" } },
    [
      _c("div", { staticClass: "f22 fb wrap pad20-t pad15-b" }, [
        _vm._v("订单详情")
      ]),
      _vm.loaded
        ? _c("div", { staticClass: "gray3 wrap" }, [
            _c(
              "div",
              { staticClass: "flex bg-white mar20-b state" },
              [
                _c("div", { staticClass: "text-center left" }, [
                  _vm.dataMasking
                    ? _c("div", { staticClass: "pad25-t pad30-b" }, [
                        _vm._v("订单编号：****")
                      ])
                    : _c("div", { staticClass: "pad25-t pad30-b" }, [
                        _vm._v("订单编号：" + _vm._s(_vm.detail.orderId))
                      ]),
                  _c(
                    "div",
                    {
                      staticClass: "fb pad50-b f26",
                      staticStyle: { color: "#71b247" }
                    },
                    [_vm._v(_vm._s(_vm.detail.orderStCn))]
                  ),
                  _c("div", {
                    staticClass:
                      "pad40-b flex flex-wrap text-center flex-item1 pad20-lr btn-group"
                  })
                ]),
                _c("order_info_dtl", { attrs: { detail: _vm.detail } })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bg-white f14 pad20" },
              [
                _c("logistics_dtl", {
                  attrs: {
                    orderDelivery: _vm.orderDelivery,
                    goodsPic: _vm.orderGoodsList[0].goodsPic,
                    dataMasking: _vm.dataMasking
                  }
                }),
                _c("order_basic_info_dtl", {
                  attrs: { detail: _vm.detail, dataMasking: _vm.dataMasking }
                }),
                _vm.detail.delivery == "2"
                  ? _c(
                      "div",
                      { staticClass: "pad20 mar20-b border" },
                      [
                        _vm._m(0),
                        _vm.detail.orderDtlBo.orderSellVehicleList.length > 0
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.detail.orderDtlBo.orderSellVehicleList,
                                function(vehicle) {
                                  return _c(
                                    "div",
                                    {
                                      key: vehicle.id,
                                      staticClass: "flex f14 flex-item1"
                                    },
                                    [
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("车牌号:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.licensePlateNum.replace(
                                                          /^(.{1}).+(.)/,
                                                          "$1**$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.licensePlateNum
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("司机:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.name.substring(
                                                          0,
                                                          1
                                                        ) +
                                                          new Array(
                                                            vehicle.name.length
                                                          ).join("*")
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [_vm._v(_vm._s(vehicle.name))]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("联系方式:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.tel.replace(
                                                          /^(.{3})(?:\d+)(.{4})$/,
                                                          "$1****$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mar10-l mar50-r"
                                                  },
                                                  [_vm._v(_vm._s(vehicle.tel))]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("身份证号:")]
                                            ),
                                            vehicle.idCard && _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.idCard.replace(
                                                          /^(.{4})(?:\d+)(.{4})$/,
                                                          "$1******$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(vehicle.idCard)
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]),
                                      _vm._m(1, true)
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._l(
                          _vm.detail.orderDtlBo.orderBuyerVehicleList,
                          function(vehicle) {
                            return _c(
                              "div",
                              {
                                key: vehicle.id,
                                staticClass: "flex f14 flex-item1"
                              },
                              [
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("车牌号:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.licensePlateNum.replace(
                                                /^(.{1}).+(.)/,
                                                "$1**$2"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(vehicle.licensePlateNum)
                                          )
                                        ])
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("司机:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.name.substring(0, 1) +
                                                new Array(
                                                  vehicle.name.length
                                                ).join("*")
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(_vm._s(vehicle.name))
                                        ])
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("联系方式:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c(
                                          "div",
                                          { staticClass: "mar10-l mar50-r" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                vehicle.tel.replace(
                                                  /^(.{3})(?:\d+)(.{4})$/,
                                                  "$1****$2"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "mar10-l mar50-r" },
                                          [_vm._v(_vm._s(vehicle.tel))]
                                        )
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("身份证号:")
                                    ]),
                                    vehicle.idCard && _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.idCard.replace(
                                                /^(.{4})(?:\d+)(.{4})$/,
                                                "$1******$2"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(_vm._s(vehicle.idCard))
                                        ])
                                  ])
                                ]),
                                _vm._m(2, true)
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "pad20 flex flex-item1 mar20-b flex-item1 border certificate"
                  },
                  [
                    _c("div", { staticClass: "item" }, [
                      _c("div", { staticClass: "f16 fb mar15-b" }, [
                        _vm._v("订单凭证")
                      ]),
                      _vm.orderCredentialList &&
                      _vm.orderCredentialList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "flex flex-item1 mar20-b" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.orderCredentialList,
                                    "header-row-class-name": "gray3 tab-header",
                                    border: "",
                                    "cell-class-name": "cell-td"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "roleName",
                                      label: "角色"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "userName",
                                      label: "姓名"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "mobilePhone",
                                      label: "手机号"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "createTime",
                                      label: "操作时间"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "optTypeCn",
                                      label: "操作事项"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "提货凭证展示"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _vm._l(
                                                scope.row.imgList,
                                                function(imgUrl, imgUrlIndex) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-wrap float-left mar5"
                                                      },
                                                      [
                                                        !_vm.isZip(imgUrl)
                                                          ? _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  imgUrl +
                                                                  "?imageView2/1/w/50/h/50",
                                                                "preview-src-list": scope.row.imgList
                                                                  .filter(
                                                                    function(
                                                                      url
                                                                    ) {
                                                                      return (
                                                                        url ===
                                                                        imgUrl
                                                                      )
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    url
                                                                  ) {
                                                                    return url
                                                                  }),
                                                                "initial-index": imgUrlIndex
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm.isZip(imgUrl)
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "line-height":
                                                                    "64px",
                                                                  display:
                                                                    "block",
                                                                  "text-align":
                                                                    "center"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href: imgUrl
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        attrs: {
                                                                          src:
                                                                            "https://files.nxin.com/mobile/public/zip.png?imageView2/1/w/50/h/50"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4255177370
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return scope.row.allowedAudit
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "c_nx_blue cursor",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.auditCredentialRecord(
                                                            scope.row,
                                                            1
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("通过")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red cursor mar10-l",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.auditCredentialRecord(
                                                            scope.row,
                                                            2
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("驳回")]
                                                  )
                                                ]
                                              : undefined
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "pad20 flex flex-item1 mar20-b flex-item1 border certificate"
                  },
                  [
                    _c("div", { staticClass: "item" }, [
                      _c("div", { staticClass: "f16 fb mar15-b" }, [
                        _vm._v("提货凭证")
                      ]),
                      _vm.auditCredentialImgList
                        ? _c(
                            "div",
                            {
                              staticClass: "relative certificate",
                              staticStyle: {
                                height: "175px",
                                "overflow-y": "auto"
                              }
                            },
                            [
                              _vm._l(_vm.auditCredentialImgList, function(
                                imgUrl
                              ) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex mar10-t mar20-b mar19-l flex-wrap float-left"
                                    },
                                    [
                                      !_vm.isZip(imgUrl)
                                        ? _c("el-image", {
                                            attrs: {
                                              src:
                                                imgUrl +
                                                "?imageView2/1/w/120/h/120",
                                              "preview-src-list": _vm.auditCredentialImgList
                                                .filter(function(url) {
                                                  return url === imgUrl
                                                })
                                                .map(function(url) {
                                                  return url
                                                })
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.isZip(imgUrl)
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "line-height": "64px",
                                                display: "block",
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                { attrs: { href: imgUrl } },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src:
                                                        "https://files.nxin.com/mobile/public/zip.png?imageView2/1/w/120/h/120"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _c("order_goods_info_dtl", {
                  attrs: {
                    orderGoodsList: _vm.orderGoodsList,
                    orderGoodsGiftBoList: _vm.orderGoodsGiftBoList,
                    dataMasking: _vm.dataMasking
                  }
                }),
                !_vm.dataMasking
                  ? _c("order_pay_info_dtl", { attrs: { detail: _vm.detail } })
                  : _vm._e()
              ],
              1
            )
          ])
        : _c("div", { staticStyle: { "min-height": "900px" } })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center mar15-b" }, [
      _c("div", { staticClass: "f16 gray3 flex-auto fb" }, [
        _vm._v("自提车辆信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }